<template>
	<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11.81396 11.75342">
		<path d="M.81054 11.75342a.75.75 0 0 1-.53027-1.28023L10.53369.21973a.74992.74992 0 1 1 1.06055 1.06054L1.34082 11.53369a.74761.74761 0 0 1-.53028.21973Z"/>
		<path d="M11.00244 11.75342a.74675.74675 0 0 1-.53027-.21973L.21972 1.28027A.74992.74992 0 1 1 1.28027.21973l10.25244 10.25346a.75.75 0 0 1-.53027 1.28028Z"/>
	</svg>
</template>
